export default __webpack_public_path__ + "1.18.21/static/media/LibreDataSharecode_Japanese.30f658c9.svg";